module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_left-5f2750cb41f98341728d2da77142da8d.svg";